









































import { User } from 'oidc-client';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser'
  })
})
export default class EditOnClickField extends Vue {
  private currentPropertyId!: string;
  private currentUser!: User;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: '' })
  private label!: string;

  @Prop({ required: false, default: '' })
  private value!: string | number | never;

  @Prop({ required: false, type: Boolean, default: true })
  private displayInline!: boolean;

  @Prop({ required: false, type: String, default: 'read' })
  private mode!: string;

  @Watch('mode')
  private async modeChanged(mode: string) {
    if (mode === 'edit' && this.canEdit) {
      // make sure
      await this.$nextTick();
      const editable = this.$refs.editable as HTMLDivElement;
      const input = editable.querySelector(
        'span input, span select, span textarea'
      ) as HTMLElement;
      if (input) {
        input.focus();
      }
      this.$emit('input-focused', input);
    }
  }

  private handleEditClicked() {
    if (this.canEdit) {
      this.$emit('mode', 'edit');
    }
  }

  private handleEscape(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.$emit('mode', 'read');
    }
  }

  private handleKeyboardForEditable(event: KeyboardEvent) {
    if (event.code === 'Space') {
      this.$emit('mode', 'edit');
      event.preventDefault();
    }
  }
}
